<template>
  <create-account-layout
    :current-step="2"
    title=""
  >
    <div class="my-5 flex flex-col items-center justify-center gap-5 pt-10">
      <h1 class="text-2xl">
        Loading
        <span class="dots">..</span>
      </h1>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="191"
        height="183"
        viewBox="0 0 191 183"
        fill="none"
      >
        <g filter="url(#filter0_d_1559_10771)">
          <path
            d="M120.332 30.7412C117.238 32.5593 112.808 33.7014 107.887 33.7014C102.966 33.7014 98.6156 32.5803 95.5252 30.7916C92.439 32.5803 88.0469 33.7014 83.1677 33.7014C78.2886 33.7014 73.8126 32.5593 70.7222 30.7412L56.3535 62.3422C54.9719 65.3754 54.2362 68.6629 54.1933 71.9957C54.1504 75.3285 54.8012 78.6338 56.1043 81.7016C57.4073 84.7694 59.3343 87.5327 61.7626 89.8158C64.191 92.0989 67.0677 93.8519 70.2099 94.9636L95.5167 103.874L120.824 94.9636C123.969 93.856 126.85 92.1058 129.282 89.8242C131.714 87.5426 133.645 84.7796 134.951 81.7111C136.257 78.6427 136.91 75.3359 136.869 72.0012C136.827 68.6666 136.092 65.3771 134.709 62.3422L120.332 30.7412Z"
            fill="#F8C617"
            fill-opacity="0.5"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M69.0622 25.5303L72.5611 27.5888C74.9721 29.0072 78.7722 30.0424 83.1453 30.0424C87.5177 30.0424 91.2444 29.0283 93.6619 27.6271L95.493 26.5658L97.3247 27.6261C99.75 29.0298 103.437 30.0424 107.847 30.0424C112.258 30.0424 116.014 29.009 118.433 27.5877L121.931 25.5329L137.977 60.803C139.569 64.2974 140.415 68.0849 140.463 71.9244C140.511 75.7639 139.759 79.5714 138.255 83.1044C136.751 86.6375 134.528 89.8188 131.728 92.4458C128.927 95.0729 125.611 97.0881 121.989 98.3633L95.4858 107.695L68.9776 98.3615C65.3598 97.0816 62.0477 95.0632 59.2519 92.4346C56.456 89.8059 54.2374 86.6245 52.7371 83.0924C51.2368 79.5602 50.4875 75.7547 50.5369 71.9175C50.5863 68.081 51.4329 64.2968 53.023 60.8051L69.0622 25.5303ZM118.477 35.5895C115.331 36.7302 111.67 37.3506 107.847 37.3506C103.263 37.3506 98.9759 36.4734 95.4938 34.891C92.0032 36.4745 87.6913 37.3506 83.1453 37.3506C79.3529 37.3506 75.6761 36.7304 72.5173 35.5879L59.6758 63.8301C58.5052 66.4001 57.8809 69.1877 57.8445 72.0115C57.8082 74.8354 58.3595 77.6359 59.4636 80.2351C60.5677 82.8344 62.2004 85.1757 64.2579 87.1101C66.3153 89.0445 68.7527 90.5298 71.4151 91.4717L95.4858 99.9466L119.562 91.4699C122.227 90.5316 124.667 89.0487 126.728 87.1157C128.789 85.1826 130.424 82.8418 131.531 80.2421C132.638 77.6424 133.191 74.8408 133.156 72.0156C133.12 69.1904 132.497 66.4035 131.326 63.8322L118.477 35.5895Z"
            fill="#F8C617"
          />
          <path
            d="M103.404 80.2289H121.04L107.927 47.6621H99.092L100.633 59.3015H90.3667L91.9077 47.6621H83.0732L69.96 80.2289H87.5954L89.1364 68.5937H101.863L103.404 80.2289Z"
            fill="white"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_1559_10771"
            x="0.573059"
            y="0.5495"
            width="189.854"
            height="182.087"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood
              flood-opacity="0"
              result="BackgroundImageFix"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="24.9808" />
            <feGaussianBlur stdDeviation="24.9808" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.972549 0 0 0 0 0.776471 0 0 0 0 0.0901961 0 0 0 0.3 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_1559_10771"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_1559_10771"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
      <p v-html="loadingMessage"></p>
    </div>
  </create-account-layout>
</template>
<script setup>
import CreateAccountLayout from '@/components/layouts/CreateAccountLayout.vue';
defineProps({
  loadingMessage: {
    type: String,
    required: true,
    default: '',
  },
});
</script>
<style scoped>
@keyframes blink {
  0% {
    opacity: 1;
  }

  33% {
    opacity: 0;
  }

  66% {
    opacity: 1;
  }
}

.dots::after {
  content: '.';
  animation: blink 1s steps(5, end) infinite;
}
</style>
